<template>
  <div>
    <h2 class="m-b-20 section-title">{{ label }}</h2>
    <div class="card m-b-40">
      <div class="row">
        <div>
          <GoodsType
            :value="4"
            @activeGoodsType="activeGoodsType"
          />
        </div>

      <div v-if="showColliContent">
        <!-- Dimensions -->
        <div class="row m-b-40">
          <div class="col-xs-1" v-if="showColliAmount">
            <InputText
              :label="$t('Colli')"
              v-model="value.colli"
              :rules="{required: true}"
            />
          </div>
          <div class="col-xs-3">
            <InputSelect
              :label="$t('type')"
              v-model="value.parcelType"
              @change="parcelTypeSelected"
              :options="loadTypesSelection"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-4">
            <DimensionsSelect
              :required="false"
              :disabledMessure="true"
              v-model="value.dimensions" />
          </div>
          <div class="col-xs-2">
            <InputText
              :label="$t('Cubic meters')"
              :disabled="cubicDisabled"
              v-model="value.cubicMeter"
            />
          </div>
          <div class="col-xs-2">
            <InputText
              :label="$t('Loadmeter')"
              :disabled="loadDisabled"
              v-model="value.loadMeter"
            />
          </div>
        </div>
        <div class="separator"></div>
        <!-- CONTENT ROW -->
        <div class="row m-b-40">
          <h2 class="col-xs-12 content-title m-b-20">{{ $t('content_title_load') }}</h2>
          <div class="col-xs-12">
            <ContentRow
              :class="value.content.length > (index + 1) ? 'm-b-20' : ''"
              :showOnlyDescription="showOnlyDescription"
              :showOrigin="showOrigin"
              :showCustoms="showCustoms"
              :isCustomsInvoiceUploaded="isCustomsInvoiceUploaded"
              v-for="(item, index) in value.content" :key="`row-${index}`"
              :deletable="value.content.length > 1"
              @setProductDetails="productSelected"
              @removeProduct="productRemoved"
              :indexInData="index"
              @deleteRow="deleteRow"
              @quantityChange="quantityChange"
              v-model="value.content[index]"
            />
          </div>
        </div>
      </div>
      <div v-if="!showColliContent">
        <!-- Dimensions -->
        <div class="row m-b-40">
          <div class="col-xs-1" v-if="showColliAmount">
            <InputText
              :label="$t('Colli')"
              v-model="value.colli"
              :rules="{required: true}"
            />
          </div>
          <div :class="showColliAmount ? 'col-xs-3' : 'col-xs-4'">
            <InputSelect
              :label="$t('type')"
              v-model="value.parcelType"
              @change="parcelTypeSelected"
              :options="loadTypesSelection"
              :rules="{required: false}"/>
          </div>
          <div class="col-xs-5">
            <DimensionsSelect
              :required="false"
              :allowed="['cm', 'm']"
              :disabledMessure="false"
              v-model="value.dimensions" />
          </div>
          <div class="col-xs-3">
            <WeightSelect
              :label="`${$t('weight_per')} ${$t('colli').toLocaleLowerCase()}`"
              v-model="value.colliWeight"
              :rules="{required: true}"/>
          </div>
        </div>
        <div class="row m-b-40">
          <div class="col-xs-8">
            <InputText
              :label="$t('desc')"
              v-model="value.description"
              :rules="{required: true}"
            />
          </div>
          <div class="col-xs-2">
            <InputText
              :label="$t('Cubic meters')"
              :disabled="cubicDisabled"
              v-model="value.cubicMeter"
            />
          </div>
          <div class="col-xs-2">
            <InputText
              :label="$t('Loadmeter')"
              :disabled="loadDisabled"
              v-model="value.loadMeter"
            />
          </div>
        </div>
      </div>
      <!-- CONTENT ROW OPTIONS -->
      <div class="clear-float">
        <Btn v-if="showColliContent"
          @click.native="addContentItem"
          class="brand float-left m-r-20"
          :icon="{
            name: 'plus',
            size: '20',
          }"
          :btnText="$t('Add content')"
        />
        <Btn
          v-if="removable"
          @click.native="removeLoad"
          class="gray float-left m-r-20"
          :icon="{
            name: 'deleteForever',
            size: '18',
          }"
          :btnText="$t('remove_colli')"
        />
      </div>
        <booking-dg-block
          :value="value"
          :custom-id="customId"
          :dg-type-shown-on-package-custom-id="dgTypeShownOnPackageCustomId"
          :show-temperature="showTemperature"
          :show-dangerous-goods="showDangerousGoods"
          @input="$emit('input', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import _ from 'lodash';
import mixin from '@/mixins/mixins.js';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import NestedSelect from '@/components/elements/inputs/nestedSelect.vue';
import DimensionsSelect from '@/components/elements/inputs/dimensionsSelect.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";

import ContentRow from "@/components/shipments/contentRow.vue";
import DangerousGoodsBlock from "@/components/shipments/dangerousGoodsBlock";
import GoodsType from "@/components/shipments/goodsType.vue";
import productSelect from "@/mixins/productSelect";
import ProductPicker from "@/components/global/productPicker/productPicker.vue";
import BookingDgBlock from "@/components/shipments/bookingDgBlock.vue";

export default {
  name: 'LoadBlock',
  mixins: [mixin,productSelect],
  components: {
    BookingDgBlock,
    ProductPicker,
    GoodsType,
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    ContentRow,
    NestedSelect,
    DangerousGoodsBlock
  },
  props: {
    isCustomsInvoiceUploaded: {
      type: Boolean,
      default: false,
    },
    dgTypeShownOnPackageCustomId: {
      type: String,
      default: '',
    },
    removable: {
      type: Boolean,
      default: false,
    },
    showColliContent: {
      type: Boolean,
      default: false,
    },
    showColliAmount: {
      type: Boolean,
      default: false,
    },
    showTemperature: {
      type: Boolean,
      default: false,
    },
    showDangerousGoods: {
      type: Boolean,
      default: false,
    },
    customId: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Parcel',
    },
    showOnlyDescription: {
      type: Boolean,
      default: false,
    },
    showOrigin: {
      type: Boolean,
      default: false,
    },
    showCustoms: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return{
          goodsType: 4,
          colli: 1,
          description: '',
          parcelType: 0, //Unknown packaging
          packagingName: '',
          colliWeight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: '',
          },
          cubicMeter: '',
          loadMeter: '',
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          isDgToggleActive: false,
          qty: 1,
          packingType: '',
          Q: '',
          packingTypeOption: 2,
          isOverpack: 0,
          allPackedInOne: 2,
          iataLimitations: '',
          iataRadioactive: '',
          iataAdditionalInfo: '',
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ],
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                value: '',
                unit: 'kg',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
        }
      },
    },
  },
  data() {
    return{
      dimnsionsDisabled: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_parcel_types',
    ]),
    loadTypesSelection() {
      if (!this.get_parcel_types) {
        return;
      }

      return [
        {text: 'Custom dimensions', value: 0},
        ...this.get_parcel_types[4].custom_packaging.map((typeOption) => {
        return {
          text: this.$t(typeOption.name),
          value: typeOption.id,
        }
      })]
    },
    cubicDisabled() {
      let dim = this.value.dimensions;
      if(dim.length.value != '' || dim.width.value || dim.height.value || this.value.loadMeter != ''){
        return true;
      } else {
        return false;
      }
    },
    loadDisabled() {
      let dim = this.value.dimensions;
      if(dim.length.value != '' || dim.width.value || dim.height.value || this.value.cubicMeter != ''){
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    removeLoad() {
      this.$emit('removeLoad');
    },
    formatUnitsToComma(num) {
      let number = num.toString();
      if(number.indexOf('.') > -1){
        number = number.replace('.', ',');
      }
      return number;
    },
    formatUnitsToDot(num) {
      let number = num.toString();
      if(number.indexOf(',') > -1){
        number = number.replace(',', '.');
      }

      return Number(number);
    },
    parcelTypeSelected(val) {
      this.$emit('input', {
        ...this.value,
        parcelType: this.loadTypesSelection.filter((option) => option.value == val)[0].value,
        packagingName: this.loadTypesSelection.filter((option) => option.value == val)[0].text,
      });
    },
    addContentItem(){
      this.$emit('input', {
        ...this.value,
        content: [...this.value.content, {
          qty: 1,
          description: '',
          unitWeight: {
            value: '',
            unit: 'kg',
          },
          unitValue: {
            value: '',
            unit: 'dkk',
          },
          hsCode: '',
          origin: '',
        }]
      });
    },
    deleteRow(index) {
      this.$emit('input', {
        ...this.value,
        content: this.value.content.filter((item, idx) => idx !== index),
      });
    },
    dimensionsDivider() {
      let messure = 1;
      if (this.value.dimensions.dimensionsType === 'cm') {
        messure = 1000000;
      } else if (this.value.dimensions.dimensionsType === 'mm') {
        messure = 1000000000;
      }
      return messure;
    },
    calculateCubic() {
      let dim = this.value.dimensions;
      let result = (
        this.formatUnitsToDot(dim.width.value) *
        this.formatUnitsToDot(dim.height.value) *
        this.formatUnitsToDot(dim.length.value)) / this.dimensionsDivider();
      return this.formatUnitsToComma(Math.trunc(result * 100) / 100);
    },
    calculateLoadmeter() {
      let dim = this.value.dimensions;
      let result = (
        this.formatUnitsToDot(dim.length.value) *
        this.formatUnitsToDot(dim.width.value) / 2.4);

      if (dim.dimensionsType === 'cm') {
        result = result / 10000;
      }
     return this.formatUnitsToComma(this.calc(result));
    },
    calc(num) {
      return num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    },
    emitCalculatedCubic() {
    this.value.cubicMeter = this.calculateCubic();
      this.$emit('input', {
        ...this.value,
        cubicMeter: this.calculateCubic(),
      });
    },
    emitResetCubic() {
      this.$emit('input', {
        ...this.value,
        cubicMeter: '',
      });
    },
    emitCalculatedLoadmeter() {
      this.$emit('input', {
        ...this.value,
        loadMeter: this.calculateLoadmeter(),
      });
    },
    emitResetLoadmeter() {
      this.$emit('input', {
        ...this.value,
        loadMeter: '',
      });
    },
    emitCalculateCubicLoad() {
      this.$emit('input', {
        ...this.value,
        cubicMeter: this.calculateCubic(),
        loadMeter: this.calculateLoadmeter(),
      });
    },
    emitResetCubicLoad() {
      this.$emit('input', {
        ...this.value,
        cubicMeter: '',
        loadMeter: '',
      });
    },
    emitDimensionsDisableUpdate(disabled) {
      this.$emit('input', {
        ...this.value,
        dimensions: {
          width: {
              value: '',
              disabled: disabled,
            },
            height: {
              value: '',
              disabled: disabled,
            },
            length: {
              value: '',
              disabled: disabled,
            },
            dimensionsType: this.value.dimensions.dimensionsType,
        },
      });
    },
    activeGoodsType(val) {
      this.$emit('activePackageGoodsType', val);
    },
  },
  watch: {
    'value.cubicMeter' (newVal, oldVal) {
      if(newVal != oldVal){
        let dim = this.value.dimensions;
        if(dim.length.value == '' && dim.width.value == '' && dim.height.value == '') {
          if(newVal != '') {
            this.emitDimensionsDisableUpdate(true);
          } else {
            this.emitDimensionsDisableUpdate(false);
          }
        }
      }
    },
    'value.loadMeter' (newVal, oldVal) {
      if(newVal != oldVal){
        let dim = this.value.dimensions;
        if(dim.length.value == '' && dim.width.value == '' && dim.height.value == '') {
          if(newVal != '') {
            this.emitDimensionsDisableUpdate(true);
          } else {
            this.emitDimensionsDisableUpdate(false);
          }
        }
      }
    },
    'value.dimensions.length.value' (newVal, oldVal) {
      if(newVal != oldVal){
        let dim = this.value.dimensions;
        if(dim.length.value == '') {
          this.emitResetCubicLoad();
          return;
        }
        if(dim.length.value != '' && dim.width.value != '' && dim.height.value != '') {
          this.emitCalculateCubicLoad();
        } else if (dim.length.value != '' && dim.width.value != '') {
          this.emitCalculatedLoadmeter();
        }

      }
    },
    'value.dimensions.width.value' (newVal, oldVal) {
      if(newVal != oldVal){
        let dim = this.value.dimensions;
        if(dim.width.value == '') {
          this.emitResetCubicLoad();
          return;
        }
        if(dim.width.value != '' && dim.length.value != '' && dim.height.value != '') {
          this.emitCalculateCubicLoad();
        } else if (dim.width.value != '' && dim.length.value != '') {
          this.emitCalculatedLoadmeter();
        }

      }
    },
    'value.dimensions.height.value' (newVal, oldVal) {
      if(newVal != oldVal){
        let dim = this.value.dimensions;
        if(dim.height.value == '') {
          this.emitResetCubic();
          return;
        }
        if(dim.height.value != '' && dim.length.value != '' && dim.width.value != '') {
          this.emitCalculatedCubic();
        }
      }
    },
    'value.dimensions.dimensionsType' (newVal, oldVal) {
       if(newVal != oldVal){
         let dim = this.value.dimensions;
         if(dim.width.value != '' && dim.width.value != '' && dim.height.value != '') {
           this.emitCalculatedCubic();
           this.emitCalculatedLoadmeter();
         }
       }
    },
    'showColliContent' (newVal, oldVal) {
      if (this.value && newVal && this.value.content.length < 1) {
        this.addContentItem()
      }
    }
  },
}
</script>
